export default __webpack_public_path__ + "static/media/chev-right-white-btn.56e9eb52.svg";